import { useState, useLayoutEffect } from 'react';

export const TwoFAPreferences = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  useLayoutEffect(() => {
    const response = fetch(
      `/wp-json/ccare/v1/user/${window.wpData.currentUserId}/2fa-status`
    );
    if (response === 'has_enabled_methods' || 'no_required_has_enabled') {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  }, []);



  return (
    <>
      <h1>Two-Factor Authentication</h1>
      <p>
        ComputerCare recommends setting up two-factor authentication to better
        secure your account.
      </p>
      <p>
        For any questions,{' '}
        <a href='https://computercare.net/contact'>please contact us</a>.
      </p>

      <div class='ccare__twofa-setup'>
        <div class='ccare__twofa-status' style={{ paddingBottom: '8px' }}>
          <div class='ccare__twofa-title'>
            <h2>2fa status</h2>
            <span>{isEnabled ? window.wpData.currentUserEmail : 'Off'}</span>
          </div>
          <div class='ccare__switch'>
            <input
              class='switch-input'
              id='configured-2fa'
              type='checkbox'
              name='configured-2fa'
            //   checked={isEnabled}
              data-user-id={window.wpData.currentUserId}
              data-nonce={window.wpData.nonce}

            />
            <label class='switch-paddle round' for='configured-2fa'></label>
            <span class='show-for-sr'>2fa status </span>
          </div>
        </div>
        <div class='ccare__twofa-setup__form'>
          <form id='ccare__twofa-setup__form' action='' method='post'>
            <input type='hidden' name='action' value='ccare__twofa_setup' />
            <input
              type='hidden'
              name='nonce'
              value="<?php echo wp_create_nonce('ccare__twofa_setup') ?>"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default TwoFAPreferences;
